import { createAction } from 'redux-actions';

const actions = {
  /**
   * [위젯] 위젯 리스트 데이터 변경하기
   */
  SET_DATA: 'widget/SET_DATA',
  setData: createAction('widget/SET_DATA'),

  /**
   * [메뉴 등록 및 편집] 메뉴 리스트 요청하기
   */
  GET_HOME_MENU_WIDGET_REQUEST: 'widget/GET_HOME_MENU_WIDGET_REQUEST',
  GET_HOME_MENU_WIDGET_SUCCESS: 'widget/GET_HOME_MENU_WIDGET_SUCCESS',
  requestHomeMenu: createAction('widget/GET_HOME_MENU_WIDGET_REQUEST'),

  /**
   * [메뉴 등록 및 편집] 메뉴 업데이트 요청
   */
  UPDATE_HOME_MENU_WIDGET_REQUEST: 'widget/UPDATE_HOME_MENU_WIDGET_REQUEST',
  UPDATE_HOME_MENU_WIDGET_SUCCESS: 'widget/UPDATE_HOME_MENU_WIDGET_SUCCESS',
  updateHomeMenu: createAction('widget/UPDATE_HOME_MENU_WIDGET_REQUEST'),

  /**
   * [위젯 등록] 위젯에 기획전 연결하기 토글
   */
  TOGGLE_WIDGET_TO_EVENT: 'widget/TOGGLE_WIDGET_TO_EVENT',
  toggleWidgetToEvent: createAction('widget/TOGGLE_WIDGET_TO_EVENT'),

  /**
   * [위젯 등록] 위젯에 기획전 연결하기 토글
   */
  TOGGLE_WIDGET_BUTTON: 'widget/TOGGLE_WIDGET_BUTTON',
  toggleWidgetButton: createAction('widget/TOGGLE_WIDGET_BUTTON'),

  /**
   *  [위젯 삭제] 위젯 삭제 요청하기
   */
  DELETE_WIDGET_SUCCESS: 'widget/DELETE_WIDGET_SUCCESS',
  deleteWidget: createAction('widget/DELETE_WIDGET_SUCCESS'),

  /**
   * [위젯 배너 아이템 등록] 브랜드 리스트 요청하기
   */
  GET_STORE_LIST_REQUEST: 'widget/GET_STORE_LIST_REQUEST',
  getStoreList: createAction('widget/GET_STORE_LIST_REQUEST'),

  /**
   * [위젯 배너 아이템 등록] 기획전 리스트 요청하기
   */
  GET_EVENT_LIST_REQUEST: 'widget/GET_EVENT_LIST_REQUEST',
  getEventList: createAction('widget/GET_EVENT_LIST_REQUEST'),

  /**
   * [위젯 배너 아이템 등록] 상품 리스트 요청하기
   */
  GET_PRODUCT_LIST_REQUEST: 'widget/GET_PRODUCT_LIST_REQUEST',
  getProductList: createAction('widget/GET_PRODUCT_LIST_REQUEST'),

  /**
   * [위젯 배너 아이템 등록] 후기 리스트 요청하기
   */
  GET_REVIEW_LIST_REQUEST: 'widget/GET_REVIEW_LIST_REQUEST',
  getReviewList: createAction('widget/GET_REVIEW_LIST_REQUEST'),

  /**
   * [위젯 배너 아이템 등록] 태그 리스트 요청하기
   */
  GET_TAG_LIST_REQUEST: 'widget/GET_TAG_LIST_REQUEST',
  getTagList: createAction('widget/GET_TAG_LIST_REQUEST'),

  /**
   *  [아이템 등록] 서브 페이지 리스트 요청하기
   */
  GET_MODAL_SUB_PAGE_LIST_REQUEST: 'widget/GET_MODAL_SUB_PAGE_LIST_REQUEST',
  getModalSubPageList: createAction('widget/GET_MODAL_SUB_PAGE_LIST_REQUEST'),

  /**
   * [위젯 배너 아이템 등록] (상품, 브랜드, 기획전, 배너)아이템 리스트 받기
   */
  GET_WIDGET_BANNER_ITEM_LINK_ID_ITEM_LIST_SUCCESS: 'widget/GET_WIDGET_BANNER_ITEM_LINK_ID_ITEM_LIST_SUCCESS',

  /**
   *  [서브 페이지] 서브 페이지 등록하기
   */
  INSERT_SUB_PAGE_REQUEST: 'widget/INSERT_SUB_PAGE_REQUEST',
  INSERT_SUB_PAGE_SUCCESS: 'widget/INSERT_SUB_PAGE_SUCCESS',
  insertSubPage: createAction('widget/INSERT_SUB_PAGE_REQUEST'),

  /**
   * [서브 페이지] 서브 페이지 편집 요청하기
   */
  EDIT_SUB_PAGE_REQUEST: 'widget/EDIT_SUB_PAGE_REQUEST',
  editSubPage: createAction('widget/EDIT_SUB_PAGE_REQUEST'),

  /**
   *  [서브 페이지] 서브 페이지 리스트 요청하기
   */
  GET_SUB_PAGE_LIST_REQUEST: 'widget/GET_SUB_PAGE_LIST_REQUEST',
  GET_SUB_PAGE_LIST_SUCCESS: 'widget/GET_SUB_PAGE_LIST_SUCCESS',
  getSubPageList: createAction('widget/GET_SUB_PAGE_LIST_REQUEST'),

  /**
   *  [서브 페이지] 서브 페이지 상태 업데이트 요청하기
   */
  UPDATE_SUB_PAGE_STATUS_REQUEST: 'widget/UPDATE_SUB_PAGE_STATUS_REQUEST',
  UPDATE_SUB_PAGE_STATUS_SUCCESS: 'widget/UPDATE_SUB_PAGE_STATUS_SUCCESS',
  updateSubPageStatus: createAction('widget/UPDATE_SUB_PAGE_STATUS_REQUEST'),

  /**
   *  [서브 페이지] 서브 페이지 삭제 요청하기
   */
  DELETE_SUB_PAGE_REQUEST: 'widget/DELETE_SUB_PAGE_REQUEST',
  DELETE_SUB_PAGE_SUCCESS: 'widget/DELETE_SUB_PAGE_SUCCESS',
  deleteSubPage: createAction('widget/DELETE_SUB_PAGE_REQUEST'),

  /**
   *  [메인 페이지 위젯 리스트] 메인 페이지 위젯 리스트 요청하기
   */
  GET_MAIN_PAGE_WIDGET_LIST_REQUEST: 'widget/GET_MAIN_PAGE_WIDGET_LIST_REQUEST',
  GET_MAIN_PAGE_WIDGET_LIST_SUCCESS: 'widget/GET_MAIN_PAGE_WIDGET_LIST_SUCCESS',
  getMainPageWidgetList: createAction('widget/GET_MAIN_PAGE_WIDGET_LIST_REQUEST'),

  /**
   *  [서브 페이지 위젯 리스트] 서브 페이지 위젯 리스트 요청하기
   */
  GET_SUB_PAGE_WIDGET_LIST_REQUEST: 'widget/GET_SUB_PAGE_WIDGET_LIST_REQUEST',
  GET_SUB_PAGE_WIDGET_LIST_SUCCESS: 'widget/GET_SUB_PAGE_WIDGET_LIST_SUCCESS',
  getSubPageWidgetList: createAction('widget/GET_SUB_PAGE_WIDGET_LIST_REQUEST'),

  /**
   * [위젯 리스트] 변경된 활성 중인 위젯 리스트 저장하기
   */
  SAVE_UPDATED_WIDGET_LIST_REQUEST: 'widget/SAVE_UPDATED_WIDGET_LIST_REQUEST',
  saveUpdatedWidgetList: createAction('widget/SAVE_UPDATED_WIDGET_LIST_REQUEST'),

  /**
   * [위젯 리스트] 변경된 전체 위젯 리스트 저장하기
   */
  SAVE_UPDATED_ALL_WIDGET_LIST_REQUEST: 'widget/SAVE_UPDATED_ALL_WIDGET_LIST_REQUEST',
  saveUpdatedAllWidgetList: createAction('widget/SAVE_UPDATED_ALL_WIDGET_LIST_REQUEST'),

  /**
   *  [위젯 전체 리스트] 위젯 전체 리스트 요청하기
   */
  GET_WIDGET_ALL_LIST_REQUEST: 'widget/GET_WIDGET_ALL_LIST_REQUEST',
  GET_WIDGET_ALL_LIST_SUCCESS: 'widget/GET_WIDGET_ALL_LIST_SUCCESS',
  getWidgetAllList: createAction('widget/GET_WIDGET_ALL_LIST_REQUEST'),

  /**
   *  [위젯 비활성 리스트] 위젯 비활성 리스트 요청하기
   */
  GET_WIDGET_INACTIVE_LIST_REQUEST: 'widget/GET_WIDGET_INACTIVE_LIST_REQUEST',
  GET_WIDGET_INACTIVE_LIST_SUCCESS: 'widget/GET_WIDGET_INACTIVE_LIST_SUCCESS',
  getWidgetInactiveList: createAction('widget/GET_WIDGET_INACTIVE_LIST_REQUEST'),

  /**
   *  [위젯 상세] 위젯 상세 데이터 요청하기
   */
  GET_WIDGET_DETAIL_REQUEST: 'widget/GET_WIDGET_DETAIL_REQUEST',
  GET_WIDGET_DETAIL_SUCCESS: 'widget/GET_WIDGET_DETAIL_SUCCESS',
  getWidgetDetail: createAction('widget/GET_WIDGET_DETAIL_REQUEST'),

  /**
   * [위젯 리스트] 위젯 미리보기 데이터 요청하기
   */
  GET_WIDGET_PREVIEW_DATA_REQUEST: 'widget/GET_WIDGET_PREVIEW_DATA_REQUEST',
  getWidgetPreviewData: createAction('widget/GET_WIDGET_PREVIEW_DATA_REQUEST'),

  /**
   * [위젯 리스트] 위젯 미리보기 비교 데이터 요청하기
   */
  GET_WIDGET_PREVIEW_COMPARE_DATA_REQUEST: 'widget/GET_WIDGET_PREVIEW_COMPARE_DATA_REQUEST',
  getWidgetPreviewCompareData: createAction('widget/GET_WIDGET_PREVIEW_COMPARE_DATA_REQUEST'),

  /**
   * 모달 토글
   */
  TOGGLE_MODAL: 'widget/TOGGLE_MODAL',
  toggleModal: createAction('widget/TOGGLE_MODAL'),

  /**
   * [위젯] 위젯 링크 타입 데이터 변경하기
   */
  SET_WIDGET_LINK_TYPE: 'widget/SET_WIDGET_LINK_TYPE',
  setWidgetLinkType: createAction('widget/SET_WIDGET_LINK_TYPE'),

  /**
   * [위젯] 위젯 탭 키 변경하기
   */
  SET_WIDGET_CURRENT_TAB_KEY: 'widget/SET_WIDGET_CURRENT_TAB_KEY',
  setWidgetCurrentTabKey: createAction('widget/SET_WIDGET_CURRENT_TAB_KEY'),

  /**
   * [위젯] 위젯 쿠폰 사용 여부 토글
   */
  TOGGLE_WIDGET_COUPON_USE_STATUS: 'widget/TOGGLE_WIDGET_COUPON_USE_STATUS',
  toggleWidgetCouponUseStatus: createAction('widget/TOGGLE_WIDGET_COUPON_USE_STATUS'),

  /**
   * [위젯] 위젯 쿠폰 변경하기
   */
  SET_WIDGET_COUPON: 'widget/SET_WIDGET_COUPON',
  setWidgetCoupon: createAction('widget/SET_WIDGET_COUPON'),

  /**
   * [위젯] 위젯 상품 변경하기
   */
  SET_WIDGET_PRODUCT: 'widget/SET_WIDGET_PRODUCT',
  setWidgetProduct: createAction('widget/SET_WIDGET_PRODUCT'),

  /**
   * [위젯] 위젯 메모 변경하기
   */
  SET_WIDGET_MEMO: 'widget/SET_WIDGET_MEMO',
  setWidgetMemo: createAction('widget/SET_WIDGET_MEMO'),

  /**
   * [위젯] 위젯 전체 리스트 설정
   */
  SET_WIDGET_ALL_LIST: 'widget/SET_WIDGET_ALL_LIST',
  setWidgetAllList: createAction('widget/SET_WIDGET_ALL_LIST'),

  /**
   * [위젯] 위젯 검색 > 위젯 타입 변경하기
   */
  SET_SEARCH_OPTION_WIDGET_TYPE: 'widget/SET_SEARCH_OPTION_WIDGET_TYPE',
  setSearchOptionWidgetType: createAction('widget/SET_SEARCH_OPTION_WIDGET_TYPE'),

  /**
   * [위젯] 위젯 검색 > 위젯 레이아웃 타입 변경하기
   */
  SET_SEARCH_OPTION_WIDGET_LAYOUT_TYPE: 'widget/SET_SEARCH_OPTION_WIDGET_LAYOUT_TYPE',
  setSearchOptionWidgetLayoutType: createAction('widget/SET_SEARCH_OPTION_WIDGET_LAYOUT_TYPE'),

  /**
   * [위젯] 위젯 검색 > 위젯 키워드 타입 변경하기
   */
  SET_SEARCH_OPTION_KEYWORD_TYPE: 'widget/SET_SEARCH_OPTION_KEYWORD_TYPE',
  setSearchOptionWidgetKeywordType: createAction('widget/SET_SEARCH_OPTION_KEYWORD_TYPE'),

  /**
   * [위젯] 위젯 검색 > 위젯  타입 변경하기
   */
  SET_SEARCH_OPTION_KEYWORD: 'widget/SET_SEARCH_OPTION_KEYWORD',
  setSearchOptionWidgetKeyword: createAction('widget/SET_SEARCH_OPTION_KEYWORD'),

  /**
   * [위젯] 위젯 검색 > 위젯 노출 기간 타입 변경하기
   */
  SET_SEARCH_OPTION_EXPOSURE_PERIOD: 'widget/SET_SEARCH_OPTION_EXPOSURE_PERIOD',
  setSearchOptionWidgetExposurePeriod: createAction('widget/SET_SEARCH_OPTION_EXPOSURE_PERIOD'),

  /**
   * [위젯] 위젯 검색 > 위젯 생성일 변경하기
   */
  SET_SEARCH_OPTION_CREATE_DATE: 'widget/SET_SEARCH_OPTION_CREATE_DATE',
  setSearchOptionWidgetCreateDate: createAction('widget/SET_SEARCH_OPTION_CREATE_DATE'),

  /**
   * [위젯] 위젯 검색 > 위젯 노출 기간 타입 변경하기
   */
  SET_SEARCH_OPTION_EXPOSURE_PERIOD_TYPE: 'widget/SET_SEARCH_OPTION_EXPOSURE_PERIOD_TYPE',
  setSearchOptionWidgetExposurePeriodType: createAction('widget/SET_SEARCH_OPTION_EXPOSURE_PERIOD_TYPE'),

  /**
   * [위젯] 위젯 노출기간 일괄 입력 데이터 변경하기
   */
  SET_PERIOD_BATCH_INFO: 'widget/SET_PERIOD_BATCH_INFO',
  setWidgetPeriodBatchInfo: createAction('widget/SET_PERIOD_BATCH_INFO'),

  /**
   * [위젯] 선택된 위젯 id 리스트 변경하기
   */
  SET_SELECTED_WIDGET_ID_LIST: 'widget/SET_SELECTED_WIDGET_ID_LIST',
  setSelectedWidgetIdList: createAction('widget/SET_SELECTED_WIDGET_ID_LIST'),

  /**
   * [위젯] 위젯 검색 데이터 리셋
   */
  RESET_WIDGET_LIST_SEARCH_DATA: 'widget/RESET_WIDGET_LIST_SEARCH_DATA',
  resetWidgetListSearchData: createAction('widget/RESET_WIDGET_LIST_SEARCH_DATA'),
};

export default actions;
